import { Injectable, inject } from '@angular/core';
import { MediaReferenceService } from '@app/services/media-reference/mediareference.service';

@Injectable()
export class MediaReferenceHelperService {
  private readonly mediaReferenceService = inject(MediaReferenceService);

  private readonly contentTypeIconMap: Record<string, string> = {
    'image/png': 'image',
    'image/jpeg': 'image',
    'image/webp': 'image',
    'application/pdf': 'picture_as_pdf',
    'text/html': 'language',
  };

  public mapContentTypeIcon(contentType: string): string {
    return this.contentTypeIconMap[contentType] || 'insert_drive_file'; // default fallback
  }

  public previewMedia(mediaReferenceId: number): void {
    this.mediaReferenceService.getMediaReferenceDownloadLink(mediaReferenceId).subscribe((url) => {
      window.open(url, '_blank', 'noopener');
    });
  }
}
